import { gql, useQuery } from '@apollo/client';
import { useEffect } from 'react';
import { ChatMessageRoleEnum, ChatMessageStatusEnum } from '@/types/GraphqlSchema';

const CHAT_SESSION_MESSAGES_QUERY = gql`
  query chatSessionMessages($chatSessionId: ID!, $limit: Int) {
    chatSessionMessages(chatSessionId: $chatSessionId, limit: $limit) {
      id
      role
      content
      status
      createdAt
      updatedAt
      chatSession {
        id
      }
    }
  }
`;

export const useGetMessages = (chatSessionId, options = {}) => {
  const { limit = 50, skip = false, ...queryOptions } = options;

  const { data, loading, error, refetch, startPolling, stopPolling } = useQuery(
    CHAT_SESSION_MESSAGES_QUERY,
    {
      variables: {
        chatSessionId,
        limit,
      },
      skip: !chatSessionId || skip,
      notifyOnNetworkStatusChange: true,
      errorPolicy: 'all',
      ...queryOptions,
    },
  );

  useEffect(() => {
    const lastMessage = data?.chatSessionMessages?.[0];
    if (
      lastMessage?.role === ChatMessageRoleEnum.Assistant &&
      (lastMessage?.status === ChatMessageStatusEnum.Sent ||
        lastMessage?.status === ChatMessageStatusEnum.Failed)
    ) {
      // If the last message is from the assistant and has been sent, stop polling
      stopPolling();
    }
  }, [data, stopPolling]);

  return {
    data,
    loading,
    error,
    refetch,
    startPolling,
    stopPolling,
  };
};
